@if (gotDgProperties) {
  <app-grid-view #gridView
    [apiPath]="dgApiPath"
    [dgActionColumn]="dgActionColumn"
    [dgColumns]="dgColumns"
    [dgPopup]="dgPopup"
    [dgProperties]="dgProperties"
    (editButtonClick)="gridToggleButtonClick($event)"
  ></app-grid-view>
}
